import React from 'react';
import styled from 'styled-components';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { formatPrice } from '../../../../shared/helpers';
const QuantityInput = styled.input `
  width: 3rem;
`;
const AdjustableQuantityItem = ({ currency, quantity, price, disabled = false, strikethrough, subtotal, onChangeQuantity }) => (React.createElement(SRow, null,
    React.createElement(SCol, { span: '8' },
        React.createElement(QuantityInput, { "aria-label": 'offer quantity', "data-ref": 'offer.quantity-input', type: 'number', value: quantity, disabled: disabled, onChange: onChangeQuantity, className: 'inline margin-right-xs' }),
        "x ",
        formatPrice(price, 2, currency),
        " ="),
    React.createElement(SCol, { span: '4', className: `text-right align-self-center${strikethrough ? ' text-strikethrough' : ''}` }, formatPrice(subtotal, 2, currency))));
export default AdjustableQuantityItem;
